// Matches the backend's serialized character limits, including basic markup.
export const PROFILE_TEXT_LIMITS = { about: 5000, experience: 2000 }

export const embeddedMedia = value =>
  /\bdata\s*:|<\s*(?:img|video|audio|iframe|object|embed|source|svg|canvas|picture)\b/i.test(
    value || '',
  )

export const validateProfileText = (value, maxLength, textOnly = true) => {
  if (maxLength && Array.from(value || '').length > maxLength) {
    return `El texto y su formato exceden el límite de ${maxLength} caracteres. Acorta el contenido.`
  }
  if (textOnly && embeddedMedia(value)) {
    return 'Solo se permite texto con formato básico, sin imágenes ni contenido incrustado.'
  }
  return undefined
}
